import React, { Component } from "react";
import { CommandBarButton } from "office-ui-fabric-react/lib/Button";
import { flatten } from "../../utils";

import ExcelFile from "../../export/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "../../export/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "../../export/ExcelPlugin/elements/ExcelColumn";

class ShipmentExelExport extends Component {
  render() {
    return (
      <ExcelFile
        hideElement={false}
        element={
          <CommandBarButton
            styles={{ root: { padding: "10px" } }}
            disabled={this.props.items.length === 0}
            iconProps={{ iconName: "ExcelLogo" }}
            title="Shipments report"
            text="Shipments report"
          />
        }
      >
        <ExcelSheet
          data={this.props.items && this.props.items.map(item => flatten(item))}
          name="Shipments"
        >
          <ExcelColumn label="Date" value="date" />
          <ExcelColumn label="Relation" value="relationByRelationId.name" />
          <ExcelColumn label="Truck" value="carrierByCarrierId.truck" />
          <ExcelColumn label="Trailer" value="carrierByCarrierId.trailer" />
          <ExcelColumn label="Cargotype" value="cargoTypeByCargoTypeId.type" />
          <ExcelColumn label="About" value="about" />
        </ExcelSheet>
      </ExcelFile>
    );
  }
}

export default ShipmentExelExport;



// WEBPACK FOOTER //
// ./src/views/Reports/_ShipmentExelExport.js